import React from 'react';
import HelpIcon from '@mui/icons-material/Help';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Interface } from 'verrific-plus-schema';
import { useStyles } from './ScoreIcon.style';

export const ScoreIcon = (score: Interface.TScore): JSX.Element | undefined => {
  const classes = useStyles();
  if (score === 1) return <></>;
  else if(score === 2) return <HelpIcon className={classes.scoreWithConflict}  fontSize='small'/>;
  else if(score === 3) return <CheckCircleIcon className={classes.highestScore} fontSize='small' />;
};